var render = function render(){var _vm=this,_c=_vm._self._c;return _c('smoo-card',{key:"remote",attrs:{"visible":_vm.$attrs.visible,"accordion":"host"},on:{"show":function($event){return _vm.$emit('show', $event)},"hidden":function($event){return _vm.$emit('hidden', $event)}},scopedSlots:_vm._u([{key:"header",fn:function(){return [_vm._v("[TODO] Hosting on remote server(s)")]},proxy:true}])},[_vm._v(" TODO ")])
}
var staticRenderFns = []

export { render, staticRenderFns }